import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { trackPageView } from './analytics';

/**
 * SPA（シングルページアプリ）でのルート遷移時に
 * 1) 画面を先頭までスクロールし直す
 * 2) Google Analytics に仮想ページビューを送信する
 * ためのユーティリティコンポーネント。
 */
const ScrollToTop = () => {
    // 現在のパス名・クエリ・ハッシュを React Router から取得
    const { pathname, search, hash } = useLocation();
    // 初回マウント時の実行を抑制するためのフラグ
    const isFirstRender = useRef(true);

    // ページトップへスクロール
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    // 2回目以降のルート変更時に GA へ仮想ページビューを送信
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        // SPA のルートが変わるたびに GA へページビューを送る
        trackPageView(`${pathname}${search}${hash}`);
    }, [pathname, search, hash]);

    // 画面に何も描画しない
    return null;
};

export default ScrollToTop;

export {};
